import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { ACCESS_TOKEN_KEY } from '../../api/http'
import AdminLayout from '../../layouts/AdminLayout.vue'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    requiresAuth?: boolean
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../../views/LoginView.vue'),
    meta: { title: '管理员登录' },
  },
  {
    path: '/',
    component: AdminLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'meal-menus',
        name: 'meal-menus',
        component: () => import('../../views/MealMenusView.vue'),
        meta: { title: '点餐菜单' },
      },
      {
        path: '',
        name: 'dashboard',
        component: () => import('../../views/DashboardView.vue'),
        meta: { title: '控制台' },
      },
      {
        path: 'users',
        name: 'users',
        component: () => import('../../views/UsersView.vue'),
        meta: { title: '用户管理' },
      },
      {
        path: 'membership',
        name: 'membership',
        component: () => import('../../views/MembershipView.vue'),
        meta: { title: '会员支付' },
      },
      {
        path: 'categories',
        name: 'categories',
        component: () => import('../../views/CategoriesView.vue'),
        meta: { title: '类别管理' },
      },
      {
        path: 'airlines',
        name: 'airlines',
        component: () => import('../../views/AirlinesView.vue'),
        meta: { title: '航司管理' },
      },
      {
        path: 'advertisements',
        name: 'advertisements',
        component: () => import('../../views/AdvertisementsView.vue'),
        meta: { title: '广告管理' },
      },
      {
        path: 'question-banks',
        name: 'question-banks',
        component: () => import('../../views/QuestionBanksView.vue'),
        meta: { title: '默认题库' },
      },
      {
        path: 'app-versions',
        name: 'app-versions',
        component: () => import('../../views/AppVersionsView.vue'),
        meta: { title: '在线升级' },
      },
      {
        path: 'feedback',
        name: 'feedback',
        component: () => import('../../views/FeedbackView.vue'),
        meta: { title: '意见反馈' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../../views/NotFoundView.vue'),
    meta: { title: '页面不存在' },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

NProgress.configure({ showSpinner: false })

router.beforeEach((to) => {
  NProgress.start()
  const token = localStorage.getItem(ACCESS_TOKEN_KEY)

  if (to.meta.requiresAuth && !token) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.name === 'login' && token) {
    return { name: 'dashboard' }
  }
  return true
})

router.afterEach((to) => {
  document.title = `${to.meta.title ?? '管理后台'} · ${import.meta.env.VITE_APP_TITLE ?? '二号位'}`
  NProgress.done()
})

router.onError(() => NProgress.done())

export default router
